<template>
  <div class="game">
    <ui :scale="scale">
      <panel class="viewport" width="100%" height="100%">
        <panel width="174px" height="100%" style="background:#f2f2f2;color:#9b9b9b">
          <battle-scene />
        </panel>
      </panel>
    </ui>
  </div>
</template>

<script>
import Ui from '@/components/Ui.vue'
import Btn from '@/components/Btn.vue'
import Flex from '@/components/Flex.vue'
import Panel from '@/components/Panel.vue'

import BattleScene from '@/scenes/BattleScene.vue'

export default {
  name: 'Game',

  components: {
    // Components
    Ui,
    Btn,
    Flex,
    Panel,

    // Scenes
    BattleScene
  },

  data () {
    return {
      scale: 4
    }
  }
}
</script>

<style lang="sass" scoped>
.game
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  display: flex
  overflow: hidden
  position: absolute
  align-items: center
  justify-content: center

.viewport
  display: flex
  align-items: center
  justify-content: center
</style>
